
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_2qdw9_13g7g_93",
  "refresh": "awsui_refresh_2qdw9_13g7g_132",
  "root-no-actions": "awsui_root-no-actions_2qdw9_13g7g_132",
  "root-variant-h2": "awsui_root-variant-h2_2qdw9_13g7g_135",
  "root-variant-h3": "awsui_root-variant-h3_2qdw9_13g7g_135",
  "root-has-description": "awsui_root-has-description_2qdw9_13g7g_135",
  "root-variant-h1": "awsui_root-variant-h1_2qdw9_13g7g_144",
  "main": "awsui_main_2qdw9_13g7g_154",
  "no-wrap": "awsui_no-wrap_2qdw9_13g7g_164",
  "main-variant-h1": "awsui_main-variant-h1_2qdw9_13g7g_170",
  "actions": "awsui_actions_2qdw9_13g7g_178",
  "actions-centered": "awsui_actions-centered_2qdw9_13g7g_183",
  "actions-variant-h1": "awsui_actions-variant-h1_2qdw9_13g7g_186",
  "actions-variant-h2": "awsui_actions-variant-h2_2qdw9_13g7g_189",
  "actions-variant-h3": "awsui_actions-variant-h3_2qdw9_13g7g_192",
  "title": "awsui_title_2qdw9_13g7g_205",
  "title-variant-h1": "awsui_title-variant-h1_2qdw9_13g7g_210",
  "title-variant-h2": "awsui_title-variant-h2_2qdw9_13g7g_217",
  "title-variant-h3": "awsui_title-variant-h3_2qdw9_13g7g_223",
  "virtual-space": "awsui_virtual-space_2qdw9_13g7g_244",
  "info": "awsui_info_2qdw9_13g7g_250",
  "description": "awsui_description_2qdw9_13g7g_254",
  "description-variant-h1": "awsui_description-variant-h1_2qdw9_13g7g_259",
  "description-variant-h2": "awsui_description-variant-h2_2qdw9_13g7g_263",
  "description-variant-h3": "awsui_description-variant-h3_2qdw9_13g7g_270",
  "heading": "awsui_heading_2qdw9_13g7g_279",
  "heading-variant-h1": "awsui_heading-variant-h1_2qdw9_13g7g_288",
  "heading-variant-h2": "awsui_heading-variant-h2_2qdw9_13g7g_293",
  "heading-variant-h3": "awsui_heading-variant-h3_2qdw9_13g7g_298",
  "heading-text": "awsui_heading-text_2qdw9_13g7g_304",
  "heading-text-variant-h1": "awsui_heading-text-variant-h1_2qdw9_13g7g_307",
  "heading-text-variant-h2": "awsui_heading-text-variant-h2_2qdw9_13g7g_315",
  "heading-text-variant-h3": "awsui_heading-text-variant-h3_2qdw9_13g7g_323",
  "counter": "awsui_counter_2qdw9_13g7g_332"
};
  